import { useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { routesProfile } from '../../../consts'
import { useCreateGrowthToolMutation, useUploadGrowthToolPreviewMutation } from '../../../api/growthTools'
import { GrowthToolForm } from './GrowthToolForm'
import type { GrowthToolFormValues } from './ZodValidationSchema'
import { extractApiErrorMessage } from '../../../utils/api'

export const CreateGrowthTool = () => {
  useLayoutEffect(() => {
    document.title = 'Создание инструмента личностного роста'
  }, [])

  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [createGrowthTool] = useCreateGrowthToolMutation()
  const [uploadGrowthToolPreview] = useUploadGrowthToolPreviewMutation()

  const handleSubmitDraft = async (data: GrowthToolFormValues) => {
    setIsLoading(true)
    try {
      const image = data.image
      const created = await createGrowthTool({
        payload: {
          title: data.title,
          description: data.description,
          source_type: data.source_type,
          content_type: data.content_type,
          status: 'published',
        },
      }).unwrap()
      if (image instanceof File) {
        await uploadGrowthToolPreview({ growthToolId: created.id, file: image }).unwrap()
      }
      toast.success('Инструмент личностного роста создан')
      navigate(`/${routesProfile.GROWTHTOOLS.path}/${created.slug || created.id}`)
    } catch (error) {
      toast.error(extractApiErrorMessage(error) ?? 'Не удалось создать инструмент личностного роста')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <GrowthToolForm onSubmitDraft={handleSubmitDraft} isLoading={isLoading} />
  )
}
